import {useRouter} from "next/router";
import localized from "../../locale/locales";
import SectionTiles from "./SectionTiles";
import Typo from "../Typo";
import imageStrength1Desktop from "../../public/img/strength1_desktop.jpg";
import imageStrength2Desktop from "../../public/img/strength2_desktop.jpg";
import imageStrength3Desktop from "../../public/img/strength3_desktop.jpg";
import imageStrength3Mobile from "../../public/img/strength3_mobile.jpg";
import imageStrength1Mobile from "../../public/img/strength1_mobile.jpg";
import imageStrength2Mobile from "../../public/img/strength2_mobile.jpg";

export default function SectionStrengthZone() {
    const {locale} = useRouter();
    const lang = localized[locale].gym.strengthZone;

    return (
        <div className="w-full overflow-hidden md:overflow-visible pt-8 md:pt-0 -mb-12 md:mb-0">
            <SectionTiles direction="left" title={lang.title} images={{
                desktop: [
                    imageStrength1Desktop,
                    imageStrength2Desktop,
                    imageStrength3Desktop,
                ],
                mobile: [
                    imageStrength3Mobile,
                    imageStrength1Mobile,
                    imageStrength2Mobile,
                ],
            }}>
                {lang.body.map((item, key) => <Typo key={`Strength: ${key}`}>{item}</Typo>)}
            </SectionTiles>
        </div>
    )
}